<template>
  <div>
    <div class="card">
      <div class="card-body">
        <!-- <sweet-button :loading="isLoading" variant="primary" icon="bx bx-plus" size="sm" class="float-right" @click="$router.push('/workspace/create')">
          {{ $t("workspace.create-a-new-workspace") }}
        </sweet-button> -->

        <!--
         <div style="width: 150px; height: 60px;">
           <div class="search-box mr-2 mb-2 d-inline-block">
             <div class="position-relative">
               <input v-model="nameFilter" type="text" class="form-control" placeholder="Ara..." />
               <i class="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        -->

        <div style="clear:both"></div>
        <right-panel class="float-right" id="sidebar-workspace-edit" width="600px" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <Form :hide-library="true" />
          </div>
        </right-panel>

        <h4 class="card-title mb-4">{{ $t("workspace.my") }}</h4>

        <div class="table-responsive mb-0" v-if="pagination && pagination.docs.length > 0">
          <table class="table table-centered table-nowrap">
            <tbody>
              <empty v-if="!pagination || pagination.docs.length == 0">
                <h5 class="text-center">
                  {{ $t("common.not-found") }}
                </h5>
              </empty>

              <tr v-for="item in pagination.docs" :key="item._id" class="hider" :class="{ 'dashed-border': item.isDeleting }">
                <td style="width: 50px;">
                  <i
                    v-if="item.isDeleting"
                    class="  mdi mdi-progress-close font-size-20"
                    v-b-tooltip.hover.left
                    :title="$t('common.is-deleting')"
                    :class="{
                      'text text-success': selectedWorkspace && selectedWorkspace._id == item._id,
                    }"
                  ></i>
                  <i
                    v-else
                    class="mdi mdi-hexagon-multiple-outline font-size-20"
                    :class="{
                      'text text-success': selectedWorkspace && selectedWorkspace._id == item._id,
                    }"
                  ></i>
                </td>
                <td>
                  <h5 v-if="item.isDeleting" class="font-size-14 m-0">
                    {{ item.name }}
                  </h5>
                  <h5 v-else class="font-size-14 m-0 hand" @click="goTo(item, `/workspace/organizations`)">
                    {{ item.name }}
                  </h5>
                </td>
                <td>
                  <span v-b-tooltip.hover.left :title="$t('common.owner')" class="arrow">
                    <letter-avatar :showName="true" :name="item.owner.name" :image="item.owner.avatar" variant="secondary" />
                  </span>
                </td>
                <td>
                  <span class="badge badge-soft-primary arrow" v-b-tooltip.hover.left :title="$t('workspace.your-role')">
                    {{ item.role.name | translate }}
                  </span>
                </td>
                <td>
                  <i v-if="item.isDeleting"></i>
                  <i
                    v-else
                    class="mdi mdi-office-building hand mr-3 font-size-16"
                    v-b-tooltip.hover.left
                    :title="$t('organization.plural')"
                    @click="goTo(item, `/workspace/organizations`)"
                  ></i>
                  <i v-if="item.isDeleting"></i>
                  <i
                    v-else
                    class="mdi mdi-account-group hand mr-3 font-size-16"
                    v-b-tooltip.hover.left
                    :title="$t('workspace.members')"
                    @click="goTo(item, `/workspace/members`)"
                  ></i>
                </td>

                <td class="text-right">
                  <i v-if="item.isDeleting"></i>
                  <i
                    v-else
                    class="bx bx-copy text-primary hand hidden mr-3"
                    v-b-tooltip.hover.left
                    :title="$t('common.duplicate')"
                    v-b-modal="'workspace-duplicate-option-modal' + item._id"
                  ></i>
                  <i v-if="item.isDeleting"></i>
                  <i v-else class="bx bx-pencil text-primary hand hidden mr-3" v-b-tooltip.hover.left :title="$t('common.edit')" @click="select(item)"></i>
                  <i v-if="item.isDeleting"></i>
                  <i
                    v-else
                    class="bx bx-trash text-danger hand hidden mr-3"
                    v-b-tooltip.hover.left
                    :title="$t('common.delete')"
                    v-b-modal="'workspace-delete-option-modal' + item._id"
                  ></i>
                  <WorkspaceDeleteOptionModal :id="'workspace-delete-option-modal' + item._id" :workspace="item" @onSuccess="() => reload()" />
                  <WorkspaceDuplicateOptionModal :id="'workspace-duplicate-option-modal' + item._id" :workspace="item" @onSuccess="() => reload()"></WorkspaceDuplicateOptionModal>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <template v-if="pagination">
          <div class="d-flex justify-content-center my-3">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" @click.native.stop size="sm"></b-pagination>
            </ul>
          </div>
        </template>
      </div>
    </div>
    <content-loading v-if="isLoading" />

    <WorkspaceFeeds />
  </div>
</template>

<script>
import WorkspaceFeeds from "./components/workspace-feeds";
import WorkspaceDeleteOptionModal from "./workspace-delete-option-modal";
import WorkspaceDuplicateOptionModal from "./workspace-duplicate-option-modal";
import Form from "./workspace-form";
export default {
  components: {
    WorkspaceDeleteOptionModal,
    WorkspaceDuplicateOptionModal,
    Form,
    WorkspaceFeeds,
  },
  data() {
    return {
      request: {
        options: { page: 1, limit: 11, sort: { name: "asc" } },
        query: {},
      },

      nameFilter: undefined,
    };
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters["workspace/isLoading"];
    },
    selectedWorkspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
    pagination() {
      return this.$store.getters["workspace/pagination"];
    },
  },

  methods: {
    rightPanelClosed() {
      this.$store.commit(`workspace/editedEntity`, null);
      this.paginate();
    },
    reload() {
      location.reload();
    },
    select(workspace) {
      this.$store.commit(`workspace/editedEntity`, { ...workspace });
      this.$root.$emit("bv::toggle::collapse", "sidebar-workspace-edit");
    },
    goTo(workspace, path) {
      this.$store.commit("switchWorkspace/selected", workspace);
      location.href = path;
    },
    paginate() {
      this.$store.dispatch(`workspace/paginate`, { pagination: this.request, showOnlyIfRequestedAccountisAdmin: true });
    },
  },
};
</script>
<style>
.hover-border-primary {
  border: 1px solid white;
}
.hover-border-primary:hover {
  border: 1px solid #556ee6 !important;
}
.dashed-border {
  border: 2px dashed rgb(87, 88, 93);
  background: rgb(244, 245, 245);
}
</style>
